export const themes = {
    light: {
        name: "Light Mode",
        className: "light",
        variables: {
            '--background': '0 0% 100%',
            '--foreground': '0 0% 3.9%',
            '--card': '0 0% 100%',
            '--card-foreground': '0 0% 3.9%',
            '--popover': '0 0% 100%',
            '--popover-foreground': '0 0% 3.9%',
            '--primary': '0 0% 9%',
            '--primary-foreground': '0 0% 98%',
            '--secondary': '0 0% 96.1%',
            '--secondary-foreground': '0 0% 9%',
            '--muted': '0 0% 96.1%',
            '--muted-foreground': '0 0% 45.1%',
            '--accent': '0 0% 96.1%',
            '--accent-foreground': '0 0% 9%',
            '--destructive': '0 84.2% 60.2%',
            '--destructive-foreground': '0 0% 98%',
            '--border': '0 0% 89.8%',
            '--input': '0 0% 89.8%',
            '--ring': '0 0% 3.9%',
            '--glass-bg': 'rgba(255, 255, 255, 0.75)',
            '--glass-border': 'rgba(255, 255, 255, 0.4)',
            '--glass-shadow': '0 12px 40px -8px rgba(31, 38, 135, 0.1)',
            '--glow-primary': '0 0 20px rgba(14, 165, 233, 0.3)',
            '--premium-gradient': 'linear-gradient(135deg, #a855f7 0%, #6366f1 50%, #0ea5e9 100%)',
        },
        previewStyle: 'bg-white border-slate-200'
    },
    dark: {
        name: "Dark Mode",
        className: "dark",
        variables: {
            '--background': '222.2 84% 4.9%',
            '--foreground': '210 40% 98%',
            '--card': '222.2 84% 4.9%',
            '--card-foreground': '210 40% 98%',
            '--popover:': '222.2 84% 4.9%',
            '--popover-foreground': '210 40% 98%',
            '--primary': '210 40% 98%',
            '--primary-foreground': '222.2 47.4% 11.2%',
            '--secondary': '217.2 32.6% 17.5%',
            '--secondary-foreground': '210 40% 98%',
            '--muted': '217.2 32.6% 17.5%',
            '--muted-foreground': '215 20.2% 65.1%',
            '--accent': '217.2 32.6% 17.5%',
            '--accent-foreground': '210 40% 98%',
            '--destructive': '0 62.8% 30.6%',
            '--destructive-foreground': '210 40% 98%',
            '--border': '217.2 32.6% 17.5%',
            '--input': '217.2 32.6% 17.5%',
            '--ring': '212.7 26.8% 83.9%',
            '--glass-bg': 'rgba(15, 23, 42, 0.7)',
            '--glass-border': 'rgba(255, 255, 255, 0.08)',
            '--glass-shadow': '0 20px 50px -12px rgba(0, 0, 0, 0.5)',
            '--glow-primary': '0 0 25px rgba(139, 92, 246, 0.25)',
            '--premium-gradient': 'linear-gradient(135deg, #a855f7 0%, #6366f1 50%, #0ea5e9 100%)',
        },
        previewStyle: 'bg-slate-900 border-slate-700'
    },
    midnight: {
        name: "Midnight OLED",
        className: "midnight dark",
        variables: {
            '--background': '260 40% 4%',
            '--foreground': '260 10% 98%',
            '--card': '260 40% 6%',
            '--card-foreground': '260 10% 98%',
            '--popover': '260 40% 4%',
            '--popover-foreground': '260 10% 98%',
            '--primary': '262 83% 58%',
            '--primary-foreground': '260 10% 98%',
            '--secondary': '260 30% 12%',
            '--secondary-foreground': '260 10% 98%',
            '--muted': '260 30% 12%',
            '--muted-foreground': '260 10% 70%',
            '--accent': '260 40% 15%',
            '--accent-foreground': '260 10% 98%',
            '--destructive': '0 62.8% 30.6%',
            '--destructive-foreground': '260 10% 98%',
            '--border': '260 30% 15%',
            '--input': '260 30% 15%',
            '--ring': '262 83% 58%',
            '--glass-bg': 'rgba(12, 10, 20, 0.8)',
            '--glass-border': 'rgba(255, 255, 255, 0.05)',
            '--glass-shadow': '0 20px 50px -12px rgba(0, 0, 0, 0.5)',
            '--glow-primary': '0 0 25px rgba(139, 92, 246, 0.25)',
            '--premium-gradient': 'linear-gradient(135deg, #a855f7 0%, #6366f1 50%, #0ea5e9 100%)',
        },
        previewStyle: 'bg-black border-purple-900/50'
    },
    emerald: {
        name: "Emerald Forest",
        className: "emerald dark",
        variables: {
            '--background': '160 40% 6%',
            '--foreground': '160 10% 98%',
            '--card': '160 40% 8%',
            '--card-foreground': '160 10% 98%',
            '--popover': '160 40% 6%',
            '--popover-foreground': '160 10% 98%',
            '--primary': '158 64% 52%',
            '--primary-foreground': '160 10% 98%',
            '--secondary': '160 30% 14%',
            '--secondary-foreground': '160 10% 98%',
            '--muted': '160 30% 16%',
            '--muted-foreground': '160 10% 70%',
            '--accent': '160 40% 20%',
            '--accent-foreground': '160 10% 98%',
            '--destructive': '0 62.8% 30.6%',
            '--destructive-foreground': '160 10% 98%',
            '--border': '160 30% 20%',
            '--input': '160 30% 20%',
            '--ring': '158 64% 52%',
            '--glass-bg': 'rgba(10, 25, 20, 0.8)',
            '--glass-border': 'rgba(255, 255, 255, 0.05)',
            '--glass-shadow': '0 20px 50px -12px rgba(0, 0, 0, 0.5)',
            '--glow-primary': '0 0 25px rgba(16, 185, 129, 0.25)',
            '--premium-gradient': 'linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)',
        },
        previewStyle: 'bg-teal-950 border-emerald-900/50'
    },
    solar: {
        name: "Solar Flare",
        className: "solar dark",
        variables: {
            '--background': '15 40% 6%',
            '--foreground': '15 10% 98%',
            '--card': '15 40% 8%',
            '--card-foreground': '15 10% 98%',
            '--popover': '15 40% 6%',
            '--popover-foreground': '15 10% 98%',
            '--primary': '15 85% 55%',
            '--primary-foreground': '15 10% 98%',
            '--secondary': '15 30% 14%',
            '--secondary-foreground': '15 10% 98%',
            '--muted': '15 30% 16%',
            '--muted-foreground': '15 10% 70%',
            '--accent': '15 40% 20%',
            '--accent-foreground': '15 10% 98%',
            '--destructive': '0 62.8% 30.6%',
            '--destructive-foreground': '15 10% 98%',
            '--border': '15 30% 20%',
            '--input': '15 30% 20%',
            '--ring': '15 85% 55%',
            '--glass-bg': 'rgba(30, 15, 10, 0.8)',
            '--glass-border': 'rgba(255, 255, 255, 0.05)',
            '--glass-shadow': '0 20px 50px -12px rgba(0, 0, 0, 0.5)',
            '--glow-primary': '0 0 25px rgba(239, 68, 68, 0.25)',
            '--premium-gradient': 'linear-gradient(135deg, #f97316 0%, #ef4444 50%, #dc2626 100%)',
        },
        previewStyle: 'bg-orange-950 border-red-900/50'
    },
    ocean: {
        name: "Deep Ocean",
        className: "ocean dark",
        variables: {
            '--background': '215 50% 10%',
            '--foreground': '215 10% 98%',
            '--card': '215 40% 12%',
            '--card-foreground': '215 10% 98%',
            '--popover': '215 50% 10%',
            '--popover-foreground': '215 10% 98%',
            '--primary': '205 90% 55%',
            '--primary-foreground': '215 10% 98%',
            '--secondary': '215 30% 18%',
            '--secondary-foreground': '215 10% 98%',
            '--muted': '215 30% 20%',
            '--muted-foreground': '215 10% 70%',
            '--accent': '215 40% 24%',
            '--accent-foreground': '215 10% 98%',
            '--destructive': '0 62.8% 30.6%',
            '--destructive-foreground': '215 10% 98%',
            '--border': '215 30% 24%',
            '--input': '215 30% 24%',
            '--ring': '205 90% 55%',
            '--glass-bg': 'rgba(15, 25, 45, 0.8)',
            '--glass-border': 'rgba(255, 255, 255, 0.05)',
            '--glass-shadow': '0 20px 50px -12px rgba(0, 0, 0, 0.5)',
            '--glow-primary': '0 0 25px rgba(56, 189, 248, 0.25)',
            '--premium-gradient': 'linear-gradient(135deg, #38bdf8 0%, #0284c7 50%, #0369a1 100%)',
        },
        previewStyle: 'bg-slate-900 border-sky-900/50'
    },
    amethyst: {
        name: "Royal Amethyst",
        className: "amethyst dark",
        variables: {
            '--background': '280 40% 8%',
            '--foreground': '280 10% 98%',
            '--card': '280 35% 10%',
            '--card-foreground': '280 10% 98%',
            '--popover': '280 40% 8%',
            '--popover-foreground': '280 10% 98%',
            '--primary': '280 80% 65%',
            '--primary-foreground': '280 10% 98%',
            '--secondary': '280 30% 16%',
            '--secondary-foreground': '280 10% 98%',
            '--muted': '280 30% 18%',
            '--muted-foreground': '280 10% 70%',
            '--accent': '280 40% 22%',
            '--accent-foreground': '280 10% 98%',
            '--destructive': '0 62.8% 30.6%',
            '--destructive-foreground': '280 10% 98%',
            '--border': '280 30% 22%',
            '--input': '280 30% 22%',
            '--ring': '280 80% 65%',
            '--glass-bg': 'rgba(25, 15, 35, 0.8)',
            '--glass-border': 'rgba(255, 255, 255, 0.05)',
            '--glass-shadow': '0 20px 50px -12px rgba(0, 0, 0, 0.5)',
            '--glow-primary': '0 0 25px rgba(192, 132, 252, 0.25)',
            '--premium-gradient': 'linear-gradient(135deg, #c084fc 0%, #9333ea 50%, #7e22ce 100%)',
        },
        previewStyle: 'bg-fuchsia-950 border-purple-900/50'
    },
    obsidian: {
        name: "Obsidian Gold",
        className: "obsidian dark",
        variables: {
            '--background': '0 0% 3%',
            '--foreground': '0 0% 98%',
            '--card': '0 0% 6%',
            '--card-foreground': '0 0% 98%',
            '--popover': '0 0% 3%',
            '--popover-foreground': '0 0% 98%',
            '--primary': '43 65% 53%',
            '--primary-foreground': '0 0% 10%',
            '--secondary': '0 0% 12%',
            '--secondary-foreground': '0 0% 98%',
            '--muted': '0 0% 14%',
            '--muted-foreground': '0 0% 70%',
            '--accent': '43 40% 20%',
            '--accent-foreground': '0 0% 98%',
            '--destructive': '0 62.8% 30.6%',
            '--destructive-foreground': '0 0% 98%',
            '--border': '0 0% 16%',
            '--input': '0 0% 16%',
            '--ring': '43 65% 53%',
            '--glass-bg': 'rgba(5, 5, 5, 0.8)',
            '--glass-border': 'rgba(212, 175, 55, 0.15)',
            '--glass-shadow': '0 20px 50px -12px rgba(212, 175, 55, 0.1)',
            '--glow-primary': '0 0 25px rgba(212, 175, 55, 0.20)',
            '--premium-gradient': 'linear-gradient(135deg, #fde047 0%, #ca8a04 50%, #854d0e 100%)',
        },
        previewStyle: 'bg-[#050505] border-[#ca8a04]/50'
    },
    crimson: {
        name: "Crimson Forge",
        className: "crimson dark",
        variables: {
            '--background': '220 15% 10%',
            '--foreground': '220 10% 98%',
            '--card': '220 15% 12%',
            '--card-foreground': '220 10% 98%',
            '--popover': '220 15% 10%',
            '--popover-foreground': '220 10% 98%',
            '--primary': '0 80% 50%',
            '--primary-foreground': '220 10% 98%',
            '--secondary': '220 15% 16%',
            '--secondary-foreground': '220 10% 98%',
            '--muted': '220 15% 18%',
            '--muted-foreground': '220 10% 70%',
            '--accent': '0 50% 25%',
            '--accent-foreground': '220 10% 98%',
            '--destructive': '0 62.8% 30.6%',
            '--destructive-foreground': '220 10% 98%',
            '--border': '220 15% 20%',
            '--input': '220 15% 20%',
            '--ring': '0 80% 50%',
            '--glass-bg': 'rgba(20, 22, 30, 0.8)',
            '--glass-border': 'rgba(220, 38, 38, 0.1)',
            '--glass-shadow': '0 20px 50px -12px rgba(0, 0, 0, 0.5)',
            '--glow-primary': '0 0 25px rgba(220, 38, 38, 0.25)',
            '--premium-gradient': 'linear-gradient(135deg, #ef4444 0%, #b91c1c 50%, #7f1d1d 100%)',
        },
        previewStyle: 'bg-slate-900 border-red-900/50'
    },
    arctic: {
        name: "Arctic Frost",
        className: "arctic",
        variables: {
            '--background': '210 20% 96%',
            '--foreground': '210 25% 15%',
            '--card': '0 0% 100%',
            '--card-foreground': '210 25% 15%',
            '--popover': '0 0% 100%',
            '--popover-foreground': '210 25% 15%',
            '--primary': '200 90% 45%',
            '--primary-foreground': '0 0% 100%',
            '--secondary': '210 20% 90%',
            '--secondary-foreground': '210 25% 15%',
            '--muted': '210 20% 94%',
            '--muted-foreground': '210 20% 45%',
            '--accent': '200 80% 94%',
            '--accent-foreground': '210 25% 15%',
            '--destructive': '0 84.2% 60.2%',
            '--destructive-foreground': '0 0% 98%',
            '--border': '210 20% 86%',
            '--input': '210 20% 86%',
            '--ring': '200 90% 45%',
            '--glass-bg': 'rgba(245, 248, 250, 0.75)',
            '--glass-border': 'rgba(255, 255, 255, 0.8)',
            '--glass-shadow': '0 12px 40px -8px rgba(100, 150, 200, 0.15)',
            '--glow-primary': '0 0 20px rgba(14, 165, 233, 0.3)',
            '--premium-gradient': 'linear-gradient(135deg, #7dd3fc 0%, #38bdf8 50%, #0284c7 100%)',
        },
        previewStyle: 'bg-slate-50 border-sky-300'
    }
};
